import ReactDOM from 'react-dom/client'
import { pipe } from 'remeda'
import type { EmptyObject } from 'type-fest'
import type { HeroProps } from '@components/Hero/Hero.types'
import { getLookbookPageData } from '@components/LookbookPage/LookbookPage.utils'
import { lazyImport } from '@helpers'
import {
  withApollo,
  withErrorBoundary,
  withExchangeRates,
  withI18next,
  withStaffPickImage,
  withSuspense,
  withTheme,
} from '@hocs'
import { withWishlist } from '../hocs/withWishlist'

const { LookbookPage } = lazyImport(
  () => import('@components/LookbookPage/LookbookPage'),
  'LookbookPage',
)

const lookbookPageEl = document.getElementById('lookbook-page')
const lookbookPageData = lookbookPageEl ? getLookbookPageData() : null

interface LookbookPageAppParams {
  heroData: HeroProps | EmptyObject
}

export const renderLookbookPageApp = ({ heroData }: LookbookPageAppParams) => {
  if (lookbookPageEl && lookbookPageData) {
    const CollectionShowcasePageApp = () => (
      <LookbookPage {...lookbookPageData} heroProps={heroData} />
    )

    const CollectionShowcasePageWrapper = pipe(
      CollectionShowcasePageApp,
      withStaffPickImage,
      withSuspense,
      withExchangeRates,
      withWishlist,
      withI18next,
      withErrorBoundary,
      withApollo,
      withTheme,
    )

    ReactDOM.createRoot(lookbookPageEl).render(
      <CollectionShowcasePageWrapper />,
    )
  }
}
